@if (isDataEmpty) {
<atx-no-data-panel
  i18n="
    No information available|A text telling the user there's no information
    available@@noInformationAvailable"
  >No information available</atx-no-data-panel
>
} @else { @for (fieldDef of componentDef.fields; track trackByFieldName($index,
fieldDef)) { @switch (fieldDef.type) {
<!-- the the panel should be able to show the attributes as icons, badges or text, being text the default -->
@default {
<div class="mb-2">
  @if (fieldDef.label && getFieldValue(fieldDef.name)) {
  <h6 class="label mb-2">
    {{ fieldDef.label }}
  </h6>
  } @if(getFieldValue(fieldDef.name)) {
  <div class="mb-3" [innerHTML]="getFieldValue(fieldDef.name) | safeHtml"></div>
  }
</div>
} } } }
